/** Embedded route document inside a daily routes template (Mongo subdoc). */
export function normalizeEmbeddedTemplateRoute(route) {
  if (!route) return null;
  const id =
    route._id != null
      ? String(route._id)
      : route.id != null
        ? String(route.id)
        : '';
  return Object.assign({}, route, { id });
}

export function findTemplateRouteByParamId(template, routeIdParam) {
  if (!template?.routes || routeIdParam == null) return null;
  const want = String(routeIdParam);
  const raw = template.routes.find(
    (r) => String(r._id || '') === want || String(r.id || '') === want
  );
  return raw ? normalizeEmbeddedTemplateRoute(raw) : null;
}
